"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveSignalsReadyFromContext = exports.resolveServiceGetterFromContext = exports.implementService = exports.defineService = void 0;
const sdk_context_1 = require("@wix/sdk-context");
var services_definitions_1 = require("@wix/services-definitions");
Object.defineProperty(exports, "defineService", { enumerable: true, get: function () { return services_definitions_1.defineService; } });
Object.defineProperty(exports, "implementService", { enumerable: true, get: function () { return services_definitions_1.implementService; } });
const resolveServiceGetterFromContext = () => sdk_context_1.wixContext?.getService || globalThis?.__wix_context__?.getService;
exports.resolveServiceGetterFromContext = resolveServiceGetterFromContext;
const resolveSignalsReadyFromContext = () => {
    const awaitRemoteSignals = sdk_context_1.wixContext?.awaitRemoteSignals ||
        globalThis?.__wix_context__?.awaitRemoteSignals ||
        (() => Promise.resolve());
    return awaitRemoteSignals();
};
exports.resolveSignalsReadyFromContext = resolveSignalsReadyFromContext;
